
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Combinations",
      function () {
        return require("private-next-pages/Combinations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Combinations"])
      });
    }
  